import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import RatingStarsWidget from '../RatingStarsWidget';
import RatingStarsWidgetEditable from '../RatingStarsWidgetEditable';
import './styles.css';

const RatingPoll = ({
  showRating,
  rating,
  count,
  onBeforeRatingUpdateHandler,
  onRatingUpdateHandler,
  onLinkClickHandler,
  countText = 'response',
  countTextPlural = 'responses',
}) => {
  const responseText = count === 1 ? countText : countTextPlural;

  return (
    <div className="rating-poll">
      {showRating ? (
        <div className="rating-poll__rating-info">
          <RatingStarsWidget
            value={Number(rating).toFixed(1)}
            size={15}
            showNumber={true}
          />
          <span
            className="rating-poll__reviews-link"
            onClick={onLinkClickHandler}
          >
            {count ? (
              <>
                <NumberFormat
                  thousandSeparator
                  value={count}
                  displayType={'text'}
                />{' '}
                {responseText}
              </>
            ) : (
              ''
            )}
          </span>
        </div>
      ) : (
        <div className="rating-poll__rating-info">
          <span className="rating-poll__rating-info-question">
            What is your perception of this firm?
          </span>
          <RatingStarsWidgetEditable
            value={0}
            size={15}
            showNumber={false}
            onChangeHandler={onRatingUpdateHandler}
            onBeforeChangeHandler={onBeforeRatingUpdateHandler}
          />
        </div>
      )}
    </div>
  );
};

RatingPoll.defaultProps = {
  showRating: true,
  onRatingUpdateHandler: () => {},
  onBeforeRatingUpdateHandler: () => {
    return true;
  },
  onLinkClickHandler: e => {
    e.preventDefault();
  },
};

RatingPoll.propTypes = {
  showRating: PropTypes.bool,
  rating: PropTypes.number,
  count: PropTypes.number,
  onLinkClickHandler: PropTypes.func,
  onRatingUpdateHandler: PropTypes.func,
  onBeforeRatingUpdateHandler: PropTypes.func,
};

export default RatingPoll;
